import {DictionaryEntries} from "@web-libs/core/internationalization/dictionary.types";

export const lengthValidator = (value: string, dict: DictionaryEntries,  minLength?: number, maxLength?: number) => {
   const mapErrorDict = dict.validator.mapErrorMessages
    if(minLength && value.length < minLength) return `${mapErrorDict.minLength} ${minLength} ${mapErrorDict.beChar}`
    if(maxLength && value.length > maxLength) return `${mapErrorDict.maxLength} ${maxLength} ${mapErrorDict.beChar}`
    return true
}
